import React from "react";
import { Paper, Typography, Grid } from "material-ui";
import TileIcon from "./../Dashboard/DashboardTiles/TileIcon";
const MinMedMaxCard = props => {
  const { minMaxMed, icon, title, units, lang, color } = props;

  return (
    <Paper className="rounded min-med-max-card">
      <div className="title">
        <Typography align="center" variant="title" color="primary">
          {title}
        </Typography>
      </div>
      <div className="body">
        <div
          className="icon"
          style={{ backgroundColor: color ? color : "#FF9100" }}
        />
        <div className="min-container">
          <Typography variant="display1">{minMaxMed.Minima}</Typography>
          <Typography variant="subheading">{units}</Typography>
          <Typography variant="subheading">{lang.Minima}</Typography>
        </div>
        <div className="med-container">
          <Typography variant="display1">{minMaxMed.Mediana}</Typography>
          <Typography variant="subheading">{units}</Typography>
          <Typography variant="subheading">{lang.Mediana}</Typography>
        </div>
        <div className="max-container">
          <Typography variant="display1">{minMaxMed.Maxima}</Typography>
          <Typography variant="subheading">{units}</Typography>
          <Typography variant="subheading">{lang.Maxima}</Typography>
        </div>
      </div>
    </Paper>
  );
};

const MinMedMaxCard2 = props => {
  const { minMaxMed, icon, title, units, lang, color } = props;

  return (
    <div className="dashboard-tile">
      <TileIcon color={color ? color : "#212121"} image={icon} />
      <Paper className="rounded scan-card-paper">
        <div className="tile-header">{title}</div>

        <Grid className="tile-body-divided" container>
          <Grid className="subbody-1" item xl={4} lg={4} md={4} sm={4} xs={4}>
            <Typography
              variant="display3"
              align="center"
              color="textSecondary"
              className="area"
            >
              {minMaxMed.Minima}
            </Typography>
            <div className="tile-descriptor">
              <span className="tile-descriptor-text">{units}</span>
            </div>
            <span className="title-reportando">{lang.Minima}</span>
          </Grid>
          <Grid className="subbody-2" item xl={4} lg={4} md={4} sm={4} xs={4}>
            <Typography
              variant="display3"
              align="center"
              color="textSecondary"
              className="headline"
            >
              {minMaxMed.Mediana}
            </Typography>
            <div className="tile-descriptor">
              <span className="tile-descriptor-text">{units}</span>
            </div>
            <span className="title-neutral">{lang.Mediana}</span>
          </Grid>
          <Grid className="subbody-3" item xl={4} lg={4} md={4} sm={4} xs={4}>
            <Typography
              variant="display3"
              align="center"
              color="textSecondary"
              className="headline"
            >
              {minMaxMed.Maxima}
            </Typography>
            <div className="tile-descriptor">
              <span className="tile-descriptor-text">{units}</span>
            </div>
            <span className="title-fallando">{lang.Maxima}</span>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default MinMedMaxCard2;



// WEBPACK FOOTER //
// ./src/containers/Scan/MinMedMaxCard.js